import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

const CardWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      sx={{
        gap: "12px",
        padding: "16px",
        border: "1px solid #DEDEDE",
        borderRadius: "8px",
        width: "100%",
      }}
    >
      {children}
    </Stack>
  );
};

type Props = {
  average_coverage: number;
  bc_members_identified: number;
  roles_below_benchmark: number;
  total_contacts_below_benchmark: number;
  total_roles: number;
};

export const ChartAnalyticsBlock = ({
  average_coverage,
  total_contacts_below_benchmark,
  roles_below_benchmark,
  bc_members_identified,
  total_roles,
}: Props) => {
  return (
    <Stack flexDirection={"row"} gap={"24px"} width={"100%"}>
      <CardWrapper>
        <Typography
          variant="h1"
          sx={{
            color: "#232323",
          }}
        >
          {average_coverage}%
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#232323",
          }}
        >
          Avg. coverage across roles
        </Typography>
      </CardWrapper>
      <CardWrapper>
        <Typography
          variant="h1"
          sx={{
            color: "#232323",
          }}
        >
          {roles_below_benchmark}
          <span style={{ color: "#9B9B9B" }}>/{total_roles}</span>
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#232323",
          }}
        >
          Roles below bench mark
        </Typography>
      </CardWrapper>
      <CardWrapper>
        <Typography
          variant="h1"
          sx={{
            color: "#232323",
          }}
        >
          {bc_members_identified}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#232323",
          }}
        >
          BC members identified
        </Typography>
      </CardWrapper>
      <CardWrapper>
        <Typography
          variant="h1"
          sx={{
            color: total_contacts_below_benchmark === 0 ? "#232323" : "#C0392B",
          }}
        >
          {`${total_contacts_below_benchmark === 0 ? "" : "-"}${total_contacts_below_benchmark}`}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#232323",
          }}
        >
          Total contacts below benchmark
        </Typography>
      </CardWrapper>
    </Stack>
  );
};
